import React, { ReactElement } from 'react'

import { CostCenterAccounting } from '../../../model/accountingIntegration'
import Company from '../../../model/company'
import { CompanyReducer } from '../../../reducers/companies'
import { FormComponentProps, withValidations } from '../../../utils/form-utils'
import { t } from '../../../utils/translation-utils'
import Button from '../../elements/button'
import Col from '../../elements/grid/col'
import Row from '../../elements/grid/row'
import Radio from '../../elements/radio'
import SwitchWrapper from '../../form-elements/SwitchWrapper'
import FeatureLock from '../../widgets/FeatureLock'
import LoadingOverlay from '../../widgets/LoadingOverlay'

type Props = {
  company: Company
  companies: CompanyReducer
  hasDimensions: boolean
}

export type AccountingDepartmentFields = {
  costCenterAccounting: CostCenterAccounting
  timeRegistrationDepartment: boolean
}

function DepartmentsForm(
  props: Props & FormComponentProps<AccountingDepartmentFields, AccountingDepartmentFields>
): ReactElement | null {
  const { decorateField, getFieldValue } = props

  return (
    <div className="departments-form">
      {props.getFormError()}
      <Row>
        <Col span={12}>
          <FeatureLock
            featureType={'Accounting Integration'}
            description={t('dimensions_tab.departments.form.cost_center_accounting.lock')}
          >
            {decorateField('costCenterAccounting', {
              title: t('dimensions_tab.departments.form.cost_center_accounting'),
              skipWrapper: true,
              noBlur: true,
            })(
              <Radio.Group>
                <Radio value={'Off'}>{t('dimensions_tab.departments.form.cost_center_accounting.off')}</Radio>
                <Radio value={'Departments'}>
                  {props.hasDimensions
                    ? t('dimensions_tab.departments.form.cost_center_accounting.departments.has_dimensions')
                    : t('dimensions_tab.departments.form.cost_center_accounting.departments')}
                </Radio>
                {props.hasDimensions && (
                  <Radio value={'CostCenters'}>
                    {t('dimensions_tab.departments.form.cost_center_accounting.cost_centers')}
                  </Radio>
                )}
              </Radio.Group>
            )}
          </FeatureLock>
        </Col>
      </Row>
      {getFieldValue('costCenterAccounting') !== 'Off' && (
        <Row>
          <Col span={12}>
            <SwitchWrapper<AccountingDepartmentFields> id={'timeRegistrationDepartment'} decorateField={decorateField}>
              {getFieldValue('costCenterAccounting') === 'Departments'
                ? t('dimensions_tab.departments.form.time_registration_department.departments')
                : t('dimensions_tab.departments.form.time_registration_department.cost_centers')}
            </SwitchWrapper>
            {getFieldValue('costCenterAccounting') === 'Departments' && (
              <p style={{ fontSize: '14px', width: '900px' }}>
                {t('dimensions_tab.departments.form.time_registration_department.note.departments')}
              </p>
            )}
            {getFieldValue('costCenterAccounting') === 'CostCenters' && (
              <p style={{ fontSize: '14px', width: '900px' }}>
                {t('dimensions_tab.departments.form.time_registration_department.note.cost_centers')}
              </p>
            )}
          </Col>
        </Row>
      )}
      <Row>
        <Col span={24}>
          <Button htmlType="submit" size="extra-extra-large" type="primary">
            {t('form.button.save_changes')}
          </Button>
        </Col>
      </Row>
      {props.companies.saving && <LoadingOverlay />}
    </div>
  )
}

export default withValidations<Props, AccountingDepartmentFields, AccountingDepartmentFields>({
  mapPropsToFields: (props) => ({
    costCenterAccounting: props.company.costCenterAccounting,
    timeRegistrationDepartment: props.company.settingsEnabled.some(
      (setting) => setting === 'DepartmentSelectTimeRegistration'
    ),
  }),
  onSubmit: (values) => values,
})(DepartmentsForm)
